import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { WINDOW } from '@polaris-customerweb/sharedcomponents.core';
import {
    ImageCdnSrcDirective,
    RoutingHelpersService,
} from '@polaris-customerweb/sharedcomponents.shared';
import {
    UserProfile,
    UserProfileService,
} from '@polaris-customerweb/sharedcomponents.user-profile';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Observable, firstValueFrom } from 'rxjs';
import { takeWhile, tap } from 'rxjs/operators';
import { NotificationComponent } from 'src/app/components/shared/components/notification/notification.component';
import { AppState } from 'src/app/models/app-state';
import { getServicesEnvironmentOverride } from 'src/app/state/culture/culture.reducer';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';
import { InfoLinkComponent } from './info-link/info-link.component';
import { PrimaryNavComponent } from './primary-nav/primary-nav.component';

@Component({
    imports: [
        AngularSvgIconModule,
        ImageCdnSrcDirective,
        InfoLinkComponent,
        MatButtonModule,
        MatMenuModule,
        NotificationComponent,
        PrimaryNavComponent,
        RouterLink,
    ],
    selector: 'rdx-main-header',
    styleUrls: ['./main-header.component.scss'],
    templateUrl: './main-header.component.html',
})
export class MainHeaderComponent implements OnInit, OnDestroy {
    @ViewChild(MatMenuTrigger) secondaryNav: MatMenuTrigger;

    brand: string;
    isAuthenticated = false;
    isOffroad: boolean;
    isServicesEnvironmentOverridden = false;
    isDestroyed = false;
    profile$ = new Observable<UserProfile>();
    isIndian = false;
    rentalsUrl: string;
    isAuthenticated$ = new Observable<boolean>();
    isServicesEnvironmentOverridden$ = new Observable<Environment>();
    logoUrl: string;
    isProd: boolean;
    isStage: boolean;

    userProfile: UserProfile | null;
    email = '';

    shoppingUrl = '';
    indianMotorcyclesRidersGroupUrl = '';
    financeUrl = '';
    insuranceUrl = '';

    constructor(
        private configService: ConfigService,
        private store: Store<AppState>,
        private routingHelpersService: RoutingHelpersService,
        private userAuthService: UserAuthService,
        private userProfileService: UserProfileService,
        @Inject(WINDOW) private window: Window
    ) {
        this.brand = this.configService.brand;
        this.isOffroad = this.configService.isOffRoad;
        this.logoUrl = '/assets/images/logo-epi.webp';
        this.isProd = this.configService.isProd;
        this.isStage = this.configService.isStage;
    }

    ngOnInit(): void {
        this.userAuthService.isAuthenticated$
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe((isAuthenticated) => {
                this.isAuthenticated = isAuthenticated;
            });

        this.isServicesEnvironmentOverridden$ = this.store
            .select(getServicesEnvironmentOverride)
            .pipe(
                tap(
                    (override) =>
                        (this.isServicesEnvironmentOverridden =
                            Boolean(override))
                )
            );

        this.isIndian = this.configService.isIndian;
        this.rentalsUrl = this.routingHelpersService.getUrlWithCulture(
            this.routingHelpersService.combineUrl(
                this.configService.rentalsUrl,
                '/'
            )
        );
        this.shoppingUrl = this.routingHelpersService.getUrlWithCulture(
            'https://www.polaris.com/en-us/shop/'
        );
        this.indianMotorcyclesRidersGroupUrl =
            this.routingHelpersService.getUrlWithCulture(
                'https://www.indianmotorcycle.com/en-us/riders-group/'
            );
        this.financeUrl = this.routingHelpersService.getUrlWithCulture(
            'https://www.polaris.com/en-us/financial-services/'
        );
        this.insuranceUrl = this.routingHelpersService.getUrlWithCulture(
            'https://www.polaris.com/en-us/insurance-services/'
        );

        void firstValueFrom(this.userProfileService.getUserProfile$()).then(
            (userProfile) => {
                this.userProfile = userProfile;
            }
        );
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    logIn(): void {
        // TODO: CLI - re-enable account effects
        // this.store.dispatch(UserAuthActions.signIn());
        this.userAuthService.logIn();
    }

    logOut(): void {
        // TODO: CLI - re-enable account effects
        // this.store.dispatch(UserAuthActions.logOut());
        this.userAuthService.logOut();
    }

    signUp(): void {
        this.userAuthService.logIn(undefined, undefined, 'signUp');
    }

    goToStage(): void {
        const url = new URL(this.window.location.href);
        url.searchParams.set('qaEnv', 'test');
        this.window.location = url.href;
    }
}
